import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { meetingsPausedMessageOf } from '../utils/meetings-pause';
import { EngagementMeetingAvailabilityBlockContract } from '../models/engagement-meeting-availability-block-contract';

export const FetchEngagementAvailabilityBlocks = createAsyncThunk(
    'engagementMeetings/fetchAvailabilityBlocks',
    async (engagementId: number, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        try {
            const response = await axios.get(
                `/api/Marketplace/Engagements/${engagementId}/EngagementMeetingAvailabilityBlocks`
            );

            if (response.status !== 200) {
                createNotification(
                    meetingsPausedMessageOf(response) ?? 'Could not fetch availability blocks at the moment.',
                    'error'
                );
                throw Object.assign(new Error('Failed to fetch availability blocks'), { isAnnounced: true });
            }

            return response.data as EngagementMeetingAvailabilityBlockContract[];
        } catch (error: any) {
            if (!error?.isAnnounced) {
                createNotification(
                    'An error occurred while fetching availability blocks.',
                    'error'
                );
            }
            throw error;
        }
    }
);

